import { Formik, Form } from 'formik';
import { validationSchema_18929 } from 'blocks/Form/data/validation';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import Phone from 'blocks/Form/fields/Phone';
import Submit from 'blocks/Form/fields/Submit';
import Address from 'blocks/Form/fields/Address';
import Title from 'blocks/Form/fields/PersonTitle';
import Organization from 'blocks/Form/fields/Organization';
import Website from 'blocks/Form/fields/Website';
import Story from 'blocks/Form/fields/Story';
import Text from 'components/Formik/Text';
import TextArea from 'components/Formik/TextArea';
import Date from 'components/Formik/Date';
import Radios from 'components/Formik/Radios';
import ProjectLocation from 'blocks/Form/fields/ProjectLocation';
import Location from 'blocks/Form/fields/Location';
import StartTime from 'blocks/Form/fields/StartTime';
import EndTime from 'blocks/Form/fields/EndTime';

/* === CORP - Request Volunteers === */

const initialValues = {
	cGFirstName: '',
	cGLasttName: '',
	cGRelationship: '',
	cGHomePhoneNumber: '',
	cGEmail: '',
	cEMItem1Name: '',
	cEMItem1QuantityOrdered: '',
	cEMItem10Name: '',
	cEMItem2Name: '',
	cEMItem1ProductNumber: '',
	cEMItem14Name: '',
	cEMItem14ProductNumber: '',
	cEMItem14QuantityOrdered: '',
	cEMItem15Name: '',
	cEMItem15ProductNumber: '',
	cEMItem15QuantityOrdered: '',
	cEMItem16Name: '',
	cEMItem16ProductNumber: '',
	cEMItem16QuantityOrdered: '',
	BillingAddress: '',
	PersonOtherAddress: '',
	info_downloaded: '',
	hCPContractDetailsFeeAmount: '',
	Notes_c: '',
	EU_Comments_pc: '',
};

const Form18929 = ({ handleSubmit, isPending, language, fields }) => {
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={values => handleSubmit('marketo', values)}
			validationSchema={validationSchema_18929}
		>
			{formik => (
				<Form className='form form--lg'>
					<h3>Person submitting application</h3>
					<div className='grid-md-2 row-gap-0'>
						<FirstName initialValues={initialValues} />
						<LastName initialValues={initialValues} />
						<Title initialValues={initialValues} />
						<Email initialValues={initialValues} />
						<Phone initialValues={initialValues} />
					</div>
					<h3>Organization</h3>
					<div className='grid-md-2 row-gap-0'>
						<Organization initialValues={initialValues} />
						<Website initialValues={initialValues} />
						<Address initialValues={initialValues} />
						<Location data={fields.location} formik={formik} initialValues={initialValues} />
					</div>
					<Story initialValues={initialValues} />
					<h3>Non-profit volunteer project contact</h3>
					<div className='grid-md-2 row-gap-0'>
						<Text label='First Name' name='cGFirstName' type='text' />
						<Text label='Last Name' name='cGLastName' type='text' />
						<Text label='Title' name='cGRelationship' type='text' />
						<Text label='Phone Number' name='cGHomePhoneNumber' type='tel' />
						<Text label='Email' name='cGEmail' type='email' />
					</div>
					<h3>Project information</h3>
					<div className='grid-md-2 row-gap-0'>
						<Text label='Project name' name='cEMItem1Name' type='text' />
						<Text label='Specific volunteer dates' name='cEMItem1QuantityOrdered' type='text' />
						<Text label='Number of volunteers needed' name='cEMItem10Name' type='text' />
						<Text label='Minimum volunteer age' name='cEMItem2Name' type='tel' />
					</div>
					<TextArea label='Overall project description' name='cEMItem1ProductNumber' type='email' />
					<h3>Project shift and length of support</h3>
					<div className='grid-lg-3 row-gap-0'>
						<Date label='Date MM/DD/YY' name='cEMItem14Name' />
						<StartTime name='cEMItem14ProductNumber' initialValues={initialValues} />
						<EndTime name='cEMItem14QuantityOrdered' initialValues={initialValues} />
						<Date label='Date MM/DD/YY' name='cEMItem15Name' />
						<StartTime name='cEMItem15ProductNumber' initialValues={initialValues} />
						<EndTime name='cEMItem15QuantityOrdered' initialValues={initialValues} />
						<Date label='Date MM/DD/YY' name='cEMItem16Name' />
						<StartTime name='cEMItem16ProductNumber' initialValues={initialValues} />
						<EndTime name='cEMItem16QuantityOrdered' initialValues={initialValues} />
					</div>
					<h3>Project location</h3>
					<div className='grid-md-2 row-gap-0'>
						<Text label='Project Location' name='BillingAddress' />
						<Text label='Address' name='PersonOtherAddress' />
						<ProjectLocation data={fields.location} formik={formik} initialValues={initialValues} />
						<Text label='Where should I park?' name='info_downloaded' />
					</div>
					<div>
						<p>Parking fee for volunteers:</p>
						<Radios
							options={[
								{
									label: 'Yes',
									value: 'Yes',
								},
								{
									label: 'No',
									value: 'No',
								},
							]}
							name='hCPContractDetailsFeeAmount'
						/>
					</div>
					<TextArea
						label='Please provide specific driving directions to project site'
						name='Notes_c'
						type='email'
					/>
					<TextArea label='Other comments' name='EU_Comments_pc' type='email' />
					<Submit
						formik={formik}
						isPending={isPending}
						pendingText={fields.submit.submitting}
						validation={fields.submit.all_required_fields}
					>
						{fields.submit.submit}
					</Submit>
				</Form>
			)}
		</Formik>
	);
};

export default Form18929;
